import React from 'react';
import type { PublicFiche } from '../../types';

interface CardProblemeProps {
  fiche: PublicFiche;
}

export const CardProbleme = ({ fiche }: CardProblemeProps) => {
  const text = fiche.probleme || fiche.solution_text || fiche.faits;
  if (!text) return null;
  return (
    <p className="font-serif text-[14px] font-light italic text-foreground leading-relaxed line-clamp-2 px-5 pt-3 pb-0">
      {text}
    </p>
  );
};